import React from "react";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Layout from "../layouts/Layout";
import { primaryShade1, primaryShade2, white } from "../styles/color";
import ExifOrientationImg from "react-exif-orientation-img";
let platform = "other";
if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

const styles = {
  bigAvatar: {
    height: "150px",
    width: "150px",
    margin: 15,
    borderRadius: "50%",
    imageOrientation: `from-image`
  }
};
class ViewProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
  }
  componentWillMount() {
    console.log(this.props);
  }
  render() {
    const { currentUser, organisations } = this.props;
    return (
      <Layout
        position="static"
        appBar
        appBarTitle={"USER PROFILE"}
        bottomNavigation={false}
        selectedValue={2}
        appBarLeftIcon={true}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItem: "center",
            margin: "55px 10px 10px 10px",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px"
            }}
          >
            {!currentUser[0].imageURL ? (
              <Avatar
                style={{
                  alignItems: "center",
                  background: primaryShade2,
                  color: "black",
                  fontSize: "3em",
                  height: "140px",
                  width: "140px"
                }}
              >
                {currentUser[0].name.charAt(0)}
              </Avatar>
            ) : platform === "ios" ? (
              <Avatar
                src={currentUser[0].imageURL}
                style={styles.bigAvatar}
                alt={currentUser[0].name.charAt(0)}
              />
            ) : (
              <ExifOrientationImg
                src={currentUser[0].imageURL}
                style={styles.bigAvatar}
                alt={currentUser[0].name.charAt(0)}
              />
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span style={{ color: primaryShade1 }}>
              <h1>{currentUser[0].name}</h1>
            </span>
          </div>
          {organisations !== "" || undefined ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <span style={{ color: primaryShade1 }}>
                <h3>{organisations.organisationName}</h3>
              </span>
            </div>
          ) : (
            ""
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span style={{ color: primaryShade1 }}>
              <h3>{currentUser[0].email}</h3>
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span style={{ color: primaryShade1 }}>
              <h3>{currentUser[0].phoneNumber}</h3>
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span style={{ color: primaryShade1 }}>
              <h3>{currentUser[0].address}</h3>
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            position: "absolute",
            bottom: "10px",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            color={primaryShade1}
            onClick={e => {
              e.preventDefault();
              this.props.history.push("/settings/updateInfo");
            }}
            style={{
              backgroundColor: primaryShade1,
              color: white
            }}
          >
            UPDATE INFO
          </Button>
        </div>
      </Layout>
    );
  }
}

export default withRouter(withUser(ViewProfile));
